export const setManagerServiceBaseUrl = 'https://35tu3wacgc.execute-api.us-west-2.amazonaws.com/dev';
export const setManagerSharedServiceBaseUrl = '';
export const OKTA_CLIENT_ID = "0oa15umr6ffi3LyDc0h8";
export const OKTA_ISSUER_URL = "https://ssodev.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://ssodev.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";